import { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Eye, EyeOff } from "lucide-react";
import { showErrorToast } from "../../utils/toast-utils";

const ResetPasswordModal = ({ onClose, onSubmit, isLoading }) => {
    const [formData, setFormData] = useState({
        newPassword: "",
        confirmPassword: "",
    });

    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showConfPassword, setShowConfPassword] = useState(false);

    const passwordRegex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({ ...prev, [name]: value }));

        if (name === "newPassword") {
            setErrors((prev) => ({
                ...prev,
                newPassword: passwordRegex.test(value)
                    ? ""
                    : "Min 8 chars, include uppercase, lowercase, number & special character",
            }));
        }

        if (name === "confirmPassword") {
            setErrors((prev) => ({
                ...prev,
                confirmPassword:
                    value !== formData.newPassword
                        ? "Passwords do not match"
                        : "",
            }));
        }
    };
  const handleSubmit = () => {
    if (!formData.newPassword || !formData.confirmPassword) {
      return showErrorToast("All fields are required");
    }

    if (formData.newPassword !== formData.confirmPassword) {
      return showErrorToast("Passwords must match");
    }

    onSubmit(formData.newPassword, formData.confirmPassword);
  };


    return (
        <>

            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40" />


            <div className="fixed inset-0 flex items-center justify-center z-50">
                <div className="bg-white rounded-2xl shadow-2xl w-[500px] p-10">
                    <h2 className="text-2xl font-bold mb-4 text-center">
                        Reset Password
                    </h2>


                    <div className="relative mb-3">
                        <Input
                            type={showPassword ? "text" : "password"}
                            name="newPassword"
                            placeholder="New Password"
                            value={formData.newPassword}
                            onChange={handleChange}
                        />

                        <Button
                            variant="admin.default"
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute right-[1px] -translate-y-1/2 text-sm text-blue-600 top-[22px] px-2"
                        >
                            {showPassword ? (
                                <EyeOff size={18} />
                            ) : (
                                <Eye size={18} />
                            )}
                        </Button>

                        {errors.newPassword && (
                            <p className="text-red-500 text-xs mt-1">
                                {errors.newPassword}
                            </p>
                        )}
                    </div>

                    {/* Confirm Password */}
                    <div className="relative  mb-3">
                        <Input
                            type={showConfPassword ? "text" : "password"}
                            name="confirmPassword"
                            placeholder="Confirm Password"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                        />

                        <Button
                            variant="admin.default"
                            onClick={() => setShowConfPassword(!showConfPassword)}
                            className="absolute right-[1px] -translate-y-1/2 text-sm text-blue-600 top-[22px] px-2"
                        >
                            {showConfPassword ? (
                                <EyeOff size={18} />
                            ) : (
                                <Eye size={18} />
                            )}
                        </Button>

                        {errors.confirmPassword && (
                            <p className="text-red-500 text-xs mt-1">
                                {errors.confirmPassword}
                            </p>
                        )}
                    </div>

                    {/* Buttons */}
                    <div className="flex justify-between mt-4">
                        <Button variant="outline" onClick={onClose}>
                            Cancel
                        </Button>

                        <Button
                            onClick={handleSubmit}
                            disabled={
                                !formData.newPassword ||
                                !formData.confirmPassword ||
                                errors.newPassword ||
                                errors.confirmPassword
                            }
                            className="bg-blue-600 text-white"
                        >
                            Reset Password
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export { ResetPasswordModal };